import { Route, Routes } from "react-router";
import Dashboard from "../app/dashboard";
import { ProtectedRoute } from "./protectedroute";
import Login from "../app/login";
import AppTheme from "../theme/theme";
import { CssBaseline } from "@mui/material";
import GoodsIn from "../app/goods-in";
import GoodsInDetails from "../app/goods-in/details";
import ExpectedDeliveryDetails from "../app/goods-in/expected-delivery";
import StockLocations from "../app/stock-locations";
import StockLocationDetails from "../app/stock-locations/details";
import Products from "../app/products";
import ProductDetails from "../app/products/details";
import Stock from "../app/stock";
import StockDetails from "../app/stock/details";
import StockRelocations from "../app/relocations";
import StockRelocationDetails from "../app/relocations/details";
import Audit from "../app/audit";
import AuditDetails from "../app/audit/details";
import ProductExpiryWarnings from "../app/stock/warnings/expiry";
import Users from "../app/users";
import UserDetails from "../app/users/details";
import NonConformanceReports from "../app/non-conformance";
import NonConformanceReportDetails from "../app/non-conformance/details";
import SyncIssues from "../app/sync-issues";
import SyncIssueDetails from "../app/sync-issues/details";

export const AppRouter = () => {
    return (
        <>
            <AppTheme>
                <CssBaseline enableColorScheme />
                <Routes>
                    <Route path="login" element={<Login />} />
                    <Route element={<ProtectedRoute redirectPath="/login" />}>
                        <Route path="/" element={<Dashboard />} />

                        {/* Login-only routes (no function key enforced) */}
                        <Route path="/products" element={<Products />} />
                        <Route path="/products/:id" element={<ProductDetails />} />
                        <Route path="/audit" element={<Audit />} />
                        <Route path="/audit/:id" element={<AuditDetails />} />
                    </Route>

                    <Route element={<ProtectedRoute redirectPath="/login" functionKey="goods_in" />}>
                        <Route path="/goods-in" element={<GoodsIn />} />
                        <Route path="/goods-in/deliveries/:id" element={<GoodsInDetails />} />
                        <Route path="/goods-in/expected-deliveries/:id" element={<ExpectedDeliveryDetails />} />
                    </Route>

                    <Route element={<ProtectedRoute redirectPath="/login" functionKey="stock_locations" />}>
                        <Route path="/locations" element={<StockLocations />} />
                        <Route path="/locations/:id" element={<StockLocationDetails />} />
                    </Route>

                    <Route element={<ProtectedRoute redirectPath="/login" functionKey="stock" />}>
                        <Route path="/stock" element={<Stock />} />
                        <Route path="/stock/:id" element={<StockDetails />} />
                        <Route path="/stock/warnings/expiry" element={<ProductExpiryWarnings />} />
                    </Route>

                    <Route element={<ProtectedRoute redirectPath="/login" functionKey="assign_stock" />}>
                        <Route path="/relocations" element={<StockRelocations />} />
                        <Route path="/relocations/:id" element={<StockRelocationDetails />} />
                    </Route>

                    <Route element={<ProtectedRoute redirectPath="/login" functionKey="users" />}>
                        <Route path="/users" element={<Users />} />
                        <Route path="/users/:id" element={<UserDetails />} />
                    </Route>

                    <Route element={<ProtectedRoute redirectPath="/login" functionKey="non_conformance" />}>
                        <Route path="/non-conformance" element={<NonConformanceReports />} />
                        <Route path="/non-conformance/:id" element={<NonConformanceReportDetails />} />
                    </Route>

                    <Route element={<ProtectedRoute redirectPath="/login" functionKey="sync_issues" />}>
                        <Route path="/sync-issues" element={<SyncIssues />} />
                        <Route path="/sync-issues/:id" element={<SyncIssueDetails />} />
                    </Route>
                    <Route path="*" element={<p>There's nothing here: 404!</p>} />
                </Routes>
            </AppTheme>
        </>
    );
};